import React from "react";
import {
  useDataGrid,
  DataGrid,
  GridColumns,
  EditButton,
  List,
  ShowButton,
  DeleteButton,
} from "@pankod/refine-mui";

export const CourseList = () => {
  const { dataGridProps } = useDataGrid({
    queryOptions: {
      retry: 1,
    },
    initialSorter: [
        {
            field: "created_at",
            order: "desc",
        },
    ],
  });

  function getFullName(params: any) {
    if (params.row.lecturer) {
      return `${params.row.lecturer?.prefix} ${params.row.lecturer?.surname} ${params.row.lecturer?.lastname}`;
    }
    return "-";
  }

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "actions",
        headerName: "Action",
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.course_id} />
              <ShowButton hideText recordItemId={row.course_id} />
              <DeleteButton hideText recordItemId={row.course_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
        sortable: false,
      },
      {
        field: "course_id",
        headerName: "Course Id",
        minWidth: 200,
        type: "number",
        valueFormatter: ({ value }) =>
          value.toLocaleString("en-US", { useGrouping: false }),
        headerAlign: "left",
        align: "left",
      },
      {
        field: "name",
        headerName: "ชื่อ หลักสูตร",
        minWidth: 200,
        type: "number",
        headerAlign: "left",
        align: "left",
      },
      {
        field: "lecturer",
        headerName: "วิทยากร",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        valueGetter: getFullName,
      },

      {
        field: "location",
        headerName: "สถานที่",
        minWidth: 100,
        headerAlign: "left",
        align: "left",
      },
      {
        field: "is_show",
        headerName: "สถานะ",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
        valueFormatter: ({ value }) => (value ? "เผยแพร่" : "ซ่อน"),
      },
      {
        field: "created_at",
        headerName: "สร้างเมื่อ",
        minWidth: 200,
        headerAlign: "left",
        align: "left",
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        getRowId={(row) => row.course_id}
        columns={columns}
        autoHeight
        disableColumnFilter={true}
      />
    </List>
  );
};
